import React from 'react';
import Carousel from 'react-bootstrap/Carousel';

const image_width = "1000";
const image_height = "600";

const Slider = ({photos}) => {
    return (<>
        <div className="home-slider-container">
            <Carousel className="home-carousel">
            {photos.map((photo, key) => (
                <Carousel.Item key={key}>
                <img src={photo.primaryPic}
                    alt={photo.name} height={image_height} width={image_width}/>
                    {/* <Carousel.Caption>
                        <h3>First label</h3>
                    </Carousel.Caption> */}
                </Carousel.Item>
            ))}
            </Carousel>
        </div>
    </>);
};

export default Slider;